export default "__VITE_ASSET__b1dd0fd7__"